import { styled, Box } from '@mui/material';

import theme from 'shared/styles/theme';

export const StyledController = styled(Box)`
  margin-bottom: ${theme.spacing(2.4)};
`;

export const StyledModalWrapper = styled(Box)`
  padding: ${theme.spacing(0.4, 3.2)};
`;
